module.exports = __webpack_public_path__ + "img/manufacture.50fd6f5.webp";